import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API_BASE, timeout: 60000 });

// ---- Auth: attach Bearer token (30-day localStorage session) ----
export const TOKEN_KEY = "hm_auth_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const WS_URL = (code, playerId, role) => {
  const proto = BACKEND.startsWith("https") ? "wss" : "ws";
  const host = BACKEND.replace(/^https?:\/\//, "");
  return `${proto}://${host}/api/ws/${code}?playerId=${encodeURIComponent(playerId)}&role=${role}`;
};

export const LOGO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/mddbd0yv_HITMASTER%20LOGO.webp";
export const GREEN_BTN_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_music-quiz-game-2/artifacts/x00rc4je_hitmaster%20player%20button.png";
export const RED_BTN_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_music-quiz-game-2/artifacts/fs9wxuhk_Challenge%20button.png";
export const DONTKNOW_BTN_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_music-quiz-game-2/artifacts/4xef0b5g_WEET%20NIE.png";
export const PLAYER_BG_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_music-quiz-game-2/artifacts/fog1aj6z_user%20interface.png";
export const HOST_BG_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_music-quiz-game-2/artifacts/izxqcc24_Background.%20host.png";
